<template>
  <div class="lf ks_left" id="model">
    <h1>培训管理系统</h1>
    <ul>
      <li v-for="(operate, path, index) in navTo.operate" :key="index">
        <router-link :to="{ path: operate.path }">
          {{ operate.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "comheader",
  data() {
    return {
      IsRouterAlive: true,
      navTo: {
        operate: [
          { name: "试卷分类", path: "/viewsGroup" },
          { name: "试题管理", path: "/" },
          { name: "试卷管理", path: "/test" },
          { name: "考试任务", path: "/task" },
          { name: "课件考试", path: "/cursewareExam" },
          { name: "学习任务", path: "/questionIndex" },
          { name: "权限管理", path: "/manager" },
          { name: "回收站", path: "/recycle" },
        ],
      },
    };
  },
  mounted() {
    var oH = document.documentElement.clientHeight;
    document.getElementById("model").style.minHeight = oH + "px";
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Common/comheader.vue